import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { Deal } from '../../types';
import { dedupeById } from '../../utils/deals';
interface Props {
  region: string;
  sub: string;
  status: string;
  deals: Deal[];
}
const QUARTERS = ['FY26 Q1', 'FY26 Q2', 'FY26 Q3'];
const FY_Q_LABEL: Record<string, Record<string, string>> = {
  '2026': {
    Q1: 'FY26 Q1',
    Q2: 'FY26 Q2',
    Q3: 'FY26 Q3'
  }
};
function buildTrendData(region: string, sub: string, status: string, deals: Deal[]) {
  const counts: Record<string, number> = {};
  const gnarrs: Record<string, number> = {};
  QUARTERS.forEach(q => {
    counts[q] = 0;
    gnarrs[q] = 0;
  });
  const matching = deals.filter(d => (region === 'Global' || d.region === region) && (!sub || sub === 'All' || d.sub_region === sub) && (!status || status === 'All' || d.status === status));
  dedupeById(matching).forEach(d => {
    const fy = d.created_fy || '';
    const q = d.created_q || '';
    const label = FY_Q_LABEL[fy]?.[q];
    if (label) {
      counts[label]++;
      gnarrs[label] += d.gnarr;
    }
  });
  return QUARTERS.map(q => ({
    quarter: q,
    requests: counts[q],
    gnarr: Math.round(gnarrs[q] / 1e4) / 100 // → $M with 2dp
  }));
}
export function TrendChart({
  region,
  sub,
  status,
  deals
}: Props) {
  const data = buildTrendData(region, sub, status, deals);
  return <div className="mx-[18px] mb-3 bg-white border border-[#e8eaf0] rounded-[10px] p-[14px_16px] shadow-[0_1px_3px_rgba(0,0,0,0.04)]" data-id="element-84" data-mp="25grxld70w0xp">
      <div className="flex gap-[14px] mb-[10px] text-[10px] text-[#667085]" data-id="element-85" data-mp="21fzja5jan5uk">
        <span className="flex items-center gap-1" data-id="element-86" data-mp="2f6bdc9zfveoc">
          <span className="w-[10px] h-[10px] rounded-[3px] inline-block" style={{
          background: '#b8cce8'
        }} data-id="element-87" data-mp="2af369kll05ec" />
          Requests
        </span>
        <span className="flex items-center gap-1" data-id="element-88" data-mp="1mnxq14bqbb3i">
          <span className="w-[10px] h-[10px] rounded-[3px] inline-block" style={{
          background: '#d4a017'
        }} data-id="element-89" data-mp="1hq5nzhhde8ll" />
          GNARR ($M)
        </span>
      </div>
      <ResponsiveContainer width="100%" height={190} data-id="element-90" data-mp="3hrvs4mrxjd6v">
        <ComposedChart data={data} margin={{
        top: 4,
        right: 8,
        bottom: 0,
        left: 0
      }} data-id="element-91" data-mp="3mr8bgxjle24p">
          <CartesianGrid stroke="rgba(0,0,0,0.05)" vertical={false} data-id="element-92" data-mp="3ri88e2spok77" />
          <XAxis dataKey="quarter" tick={{
          fontSize: 9,
          fill: '#8892a0'
        }} axisLine={false} tickLine={false} data-id="element-93" data-mp="3rj03zdmb6hxh" />
          <YAxis yAxisId="left" tick={{
          fontSize: 9,
          fill: '#8892a0'
        }} axisLine={false} tickLine={false} data-id="element-94" data-mp="dqc1ger7tl8" />
          <YAxis yAxisId="right" orientation="right" tick={{
          fontSize: 9,
          fill: '#8892a0'
        }} axisLine={false} tickLine={false} data-id="element-95" data-mp="2yvvtwu8czdeu" />
          <Tooltip contentStyle={{
          fontSize: 11,
          border: '1px solid #e8eaf0',
          borderRadius: 6
        }} formatter={(v: number, name: string) => [name === 'gnarr' ? '$' + v + 'M' : v, name === 'gnarr' ? 'GNARR ($M)' : 'Requests']} data-id="element-96" data-mp="38r7azj78owpr" />
          <Legend wrapperStyle={{
          display: 'none'
        }} data-id="element-97" data-mp="s2boqcuxbdwa" />
          <Bar yAxisId="left" dataKey="requests" fill="#b8cce8" radius={[3, 3, 0, 0]} name="requests" data-id="element-98" data-mp="s5659tatgekf" />
          <Line yAxisId="right" type="monotone" dataKey="gnarr" stroke="#d4a017" strokeWidth={2.5} dot={{
          fill: '#d4a017',
          r: 4
        }} activeDot={{
          r: 5
        }} name="gnarr" data-id="element-99" data-mp="2cmymq9qvqy6t" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>;
}